// dependencies
import React from "react";
import { List } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "yarrr";
import { Grid3X3 } from "lucide-react";

// components
import Grid from "../../../Components/Grid";
import Spacer from "../../../Components/Spacer";
import Company from "./components/Company";
import Paginator from "Components/Paginator";
import TextInput from "Components/Inputs/Text";

// actions
import { init, fetchPageData, updateSearch, changePage } from "./actions";

// selectors
import { getIsRequesting } from "Selectors/app";
import { getPageCount, getCurrentPage, getCompanies, getSearchInput } from "./selectors";

// css
import css from "./Page";

class CompaniesPage extends React.PureComponent {
	static propTypes = {
		init: PropTypes.func.isRequired,
		fetchPageData: PropTypes.func.isRequired,
		updateSearch: PropTypes.func.isRequired,
		changePage: PropTypes.func.isRequired,
		isRequesting: PropTypes.bool.isRequired,
		environment: PropTypes.string.isRequired,
		searchInput: PropTypes.string.isRequired,
		pageCount: PropTypes.number.isRequired,
		currentPage: PropTypes.number.isRequired,
		companies: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {};

	componentDidMount = () => {
		this.props.init();
	};

	componentDidUpdate = (prevProps) => {
		if (prevProps.environment !== this.props.environment) {
			this.props.fetchPageData();
		}
	};

	handleSearchChange = (value) => {
		this.props.updateSearch(value);
	};

	changePage = (page) => {
		this.props.changePage(page);
	};

	render = () => {
		const { searchInput, companies, isRequesting, currentPage, pageCount } = this.props;

		return (
			<div className={css.CompaniesSearchWrapper}>
				<div className={css.companiesContainer}>
					<Grid columns={["1fr", "250px"]}>
						<div />

						<div style={{ textAlign: "right" }}>
							<Link className={css.companyMatrixLink} href="/companies/matrix">
								<Grid3X3 style={{ marginRight: 8 }} size={16} />
								View Company Matrix
							</Link>
						</div>
					</Grid>

					<Spacer size={2} />

					<div>
						<div className={css.label}>Search Companies</div>
						<TextInput onChange={this.handleSearchChange} value={searchInput} />
					</div>

					<div className={css.companiesList}>
						{companies.map((company) => (
							<Company key={company.get("id")} company={company} />
						))}
					</div>

					<div className={css.paginatorWrapper}>
						<Paginator
							isRequesting={isRequesting}
							onClick={this.changePage}
							pageCount={pageCount}
							currentPage={currentPage}
						/>
					</div>
				</div>
			</div>
		);
	};
}

const mapStateToProps = (state) => ({
	companies: getCompanies(state),
	pageCount: getPageCount(state),
	currentPage: getCurrentPage(state),
	searchInput: getSearchInput(state),
	isRequesting: getIsRequesting(state, "COMPANIES:SEARCH"),
});

const mapDispatchToProps = (dispatch) => ({
	fetchPageData: () => dispatch(fetchPageData()),
	changePage: (page) => dispatch(changePage(page)),
	updateSearch: (value) => dispatch(updateSearch(value)),
	init: (graphWidth) => dispatch(init(graphWidth)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesPage);
